module.exports = __webpack_public_path__ + "media/images/homes/qr_code_ordering2x-7d4aaff79a19164a3188cb1271b5a422.png";